import store from "../store";
import { EventBus } from "@/EventBus";

export default {
  acquireSilentToken: function() {
    return new Promise((resolve) => {
      const config = {
        auth: {
          clientId: process.env.VUE_APP_clientId,
          authority: process.env.VUE_APP_tenant,
          prompt: "select_account",
        },
        cache: {
          cacheLocation: "sessionStorage",
          storeAuthStateInCookie: false,
        },
      };
      let uaa = new Msal.UserAgentApplication(config);
      const loginRequest = {
        scopes: process.env.VUE_APP_scopes.split(","),
      };
      uaa
        .acquireTokenSilent(loginRequest)
        .then(function(tokenResponse) {
          var token = tokenResponse.accessToken;
          store.commit("login", token);
          store.commit("user", {
            user: tokenResponse.account,
          });
          resolve(token);
        })
        .catch(function(error) {
          if (error && error.name === "InteractionRequiredAuthError") {
            return msalnstance
              .acquireTokenPopup(tokenRequest)
              .then(function(tokenResponse) {
                var token = tokenResponse.accessToken;
                store.commit("login", token);
                store.commit("user", {
                  user: tokenResponse.account,
                });
                EventBus.$emit("done");
                resolve(token);
              })
              .catch((err) => {
                EventBus.$emit("done");
              });
          } else {
            EventBus.$emit("done");
          }
        });
    });
  },
};
